import React from 'react';
import { formatCondition, highlightText } from './RuleConditionFormatter';

const sidMap = {
    'S-1-1-0': 'Everyone',
    'S-1-5-32-544': 'Local Administrators',
};

const convertSID = (sid) => {
    return sidMap[sid] ? `${sid} (${sidMap[sid]})` : sid;
};

export const RuleCard = ({ rule, ruleIdx, searchQuery }) => {
    const action = rule.getAttribute('Action');
    const name = rule.getAttribute('Name') || '';
    const id = rule.getAttribute('Id') || '';
    const description = rule.getAttribute('Description') || 'No description provided.';
    const sid = rule.getAttribute('UserOrGroupSid') || '';

    const conditions = rule.getElementsByTagName('Conditions')[0];
    const exceptions = rule.getElementsByTagName('Exceptions')[0];

    return (
        <div key={ruleIdx} className="card cardshadow mb-3">
            <div className="card-header flex justify-between items-start flex-wrap">
                <div className="flex flex-col">
                    <h3 className="card-title">{highlightText(name, searchQuery)}</h3>
                    <span className="text-sm text-muted mt-1">
                        <span className="badge badge-outline text-default">ID</span> {highlightText(id, searchQuery)}
                    </span>
                    <p className="text-sm text-gray-600 mb-0 mt-1">
                        <span className="badge badge-outline text-default">Description</span> {highlightText(description, searchQuery)}
                    </p>
                    <p className="text-sm text-gray-600 mb-0 mt-1">
                        <span className="badge badge-outline text-default">SID</span> {highlightText(convertSID(sid), searchQuery)}
                    </p>
                </div>
            </div>

            <div className={`ribbon ${action === "Allow" ? "bg-green" : "bg-red"}`}>
                {action}
            </div>

            <div className="card-body p-2">
                <h4 className="font-semibold mb-1">Conditions:</h4>

                <div className="list-group list-group-flush">
                    {conditions ? (
                        Array.from(conditions.children).map((cond, condIdx) => (
                            <p key={condIdx} className="list-group-item p-1 border-0">
                                {formatCondition(cond, searchQuery)}
                            </p>
                        ))
                    ) : (
                        <p>No conditions specified.</p>
                    )}

                    {exceptions && (
                        <>
                            <h4 className="font-semibold mt-4 mb-1 text-red-500">Exceptions:</h4>
                            {Array.from(exceptions.children).map((exc, excIdx) => (
                                <a key={excIdx} className="list-group-item p-1 border-0">
                                    {formatCondition(exc, searchQuery)}
                                </a>
                            ))}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};